'use client';
import { useRouter } from 'next/navigation';

// Retour vers la page précédente ; fallback vers /login/merchant en accès direct
// (jamais vers /, qui ne doit pas être une destination).
export default function BackLink({ label = '← Retour' }: { label?: string }) {
  const router = useRouter();

  const handleClick = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push('/login/merchant');
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{ background: 'none', border: 'none', padding: 0, color: 'var(--accent-text)', fontWeight: 600, fontSize: '1rem', cursor: 'pointer', fontFamily: 'inherit' }}
    >
      {label}
    </button>
  );
}
